import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import AttendanceForm from './AttendanceForm';
import { getAttendance } from '../../../redux/reduxApi/AttendanceReduxApi.js'
import { useDispatch, useSelector } from "react-redux";
import { pageData } from '../../../utils/paginationConfig.js';
import { toast } from "react-toastify";
import ProgressBar from '../../../utils/progressBar/ProgressBar.js';
import Pagination from '../../../utils/pagination/Pagination.js'
import { Trash2, SquarePen, Eye, Plus } from 'lucide-react';
import { deleteAttendance } from '../../../redux/api/attendanceApi/AttendanceApi.js';
import { deleteAttendanceAction } from '../../../redux/reduxSlice/AttendanceSlice.js';
import { countAttendance } from '../../../redux/api/attendanceApi/AttendanceApi.js';
import { Spinner } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Checkbox,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  ModalCloseButton
} from '@chakra-ui/react';
import EllipsisMenu from '../../../utils/EllipsisDropdown/EllipsisMenu.js';
import { formatDate } from '../../../utils/commonFunction/CommonFunction.js';
import("./Attendance.css");

function Attendance({ sidebarColor }) {

  const dispatch = useDispatch();
  const [deleteAttendanceId, setdeleteAttendanceId] = useState("");
  const [showProgressBar, setShowProgressBar] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [timesheetROWID, setTimesheetROWID] = useState("");
  const [loading, setLoading] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(5);
  const [isOpen, setIsOpen] = useState(false);
  const getAttendanceData = useSelector((state) => state?.timesheet?.timesheet);
  const [attendanceData, setattendanceData] = useState([]);
  const [data, setData] = useState([]);
  const [dataToEdit, setDataToEdit] = useState({});
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const navigate = useNavigate();

  //to show add & delete button according to permissions
  const permissions = localStorage.getItem('permissions');
  const filterData = JSON.parse(permissions);
  console.log("filtedata", filterData)
  // console data to be displayed
  useEffect(() => {
    setattendanceData(getAttendanceData);
  }, [getAttendanceData]);

  // Get timesheet -->
  useEffect(() => {
    const page = 1;
    setLoading(true);
    dispatch(getAttendance(page)).then((response) => {
    }).catch((error) => {
      console.log(error)
    }).finally(() => {
      setLoading(false);
      setTimeout(() => {
      }, [300])
    })
  }, [])


  // total companies count
  const fetchTotalCount = async () => {
    try {
      const response = await countAttendance();
      const count = parseInt(response.data.count, 10);
      setTotalCount(count);
    } catch (error) {
      console.error("Error fetching total Attendance count:", error);
    }
  };

  useEffect(() => {
    fetchTotalCount();
  }, []);

  // Handle Delete Function
  const handleDelete = () => {
    setShowProgressBar(true);
    setLoading(true);
    const idsToDelete = selectedRows.length === 0 ? [deleteAttendanceId] : selectedRows;
    Promise.all(idsToDelete.map(id => deleteAttendance(id)))
      .then(() => {
        setData(prevData => prevData.filter(item => !idsToDelete.includes(item.timeSheet.ROWID)));
        dispatch(deleteAttendanceAction(idsToDelete));
        fetchTotalCount()
        toast.success("Row Deleted successfully");
        fetchTotalCount();
      })
      .catch((error) => {
        console.log(error);
        toast.error("Row not deleted");
      })
      .finally(() => {
        setShowProgressBar(false);
        setLoading(false);
        closeTrash();
        setSelectedRows([]);
        setTimesheetROWID("");
      });
  };

  // handle update
  const handleUpdate = (id) => {
    setTimesheetROWID(id)
    setIsUpdateMode(!isUpdateMode)
  }


  useEffect(() => {
    if (attendanceData && attendanceData.length > 0) {
      setData(attendanceData);
    }
  }, [attendanceData]);

  useEffect(() => {
    if (currentPage % pageData.apiHit === 0) {
      const page = currentPage / pageData.apiHit + 1;
      dispatch(getAttendance(page));
    }
  }, [totalPages]);


  const openDrawer = () => {
    setIsDrawerOpen(true)
  }
  const closeDrawer = () => {
    setIsDrawerOpen(false)
  }
  // for Trash modal
  const openTrash = () => {
    setIsOpen(true)
  }
  const closeTrash = () => {
    setIsOpen(false)
  }
  // Single Select
  const handleRowSelect = (ROWID) => {
    const isSelected = selectedRows.includes(ROWID);
    let newSelectedRows = [];

    if (!isSelected) {
      newSelectedRows = [...selectedRows, ROWID];
    } else {
      newSelectedRows = selectedRows.filter(
        (rowTimesheetId) => rowTimesheetId !== ROWID
      );
    }
    setSelectedRows(newSelectedRows);
    setTimesheetROWID(newSelectedRows.join(","));
  };
  // All Select
  const handleSelectAllRows = () => {
    const allSelected = selectedRows.length === data.length;
    let newSelectedRows = [];
    if (!allSelected) {
      newSelectedRows = data.map((item) => item.timeSheet?.ROWID);
    }
    setSelectedRows(newSelectedRows);
  };

  // when a new company is added
  const handleNewAttendanceAdded = () => {
    fetchTotalCount();
  };

  return (
    <>
      {loading && (
        <div className="spinner-overlay">
          <Spinner size="xl" color="pink.500" />
        </div>
      )}
      {showProgressBar && <ProgressBar colorScheme="pink" />}
      <Modal isOpen={isOpen} onClose={closeTrash}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Are you sure you want to Delete?</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
          </ModalBody>
          <ModalFooter>
            <Button className='create-button' mr={3} onClick={handleDelete}>
              Delete
            </Button>
            <Button className='cancel-button' onClick={closeTrash}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <div >
        <div className='d-flex justify-content-end' onClick={openDrawer}>
          {/* <button className="new-button mx-2" ><Plus size="18px" /><span className='ms-1' onClick={openDrawer} >New</span></button> */}
          {selectedRows.length === 0 && (
            <>
              {filterData?.find(mod => mod.moduleName === "Addendance" && mod.add === true) && (
                <button className="new-button mx-2" onClick={openDrawer}>
                  <Plus size="18px" />
                  <span className="ms-1">New</span>
                </button>)}
            </>
          )}
        </div>
        {selectedRows.length > 0 && (
          <>

            {filterData?.find(mod => mod.moduleName === "Attendance" && mod.delete === true) && (
              <button className="new-button mx-2" onClick={openTrash}>
                <Plus size="18px" />
                <span className="ms-1">Delete All</span>
              </button>)}
          </>

        )}
        <div className='custom-scroll ' style={{ minHeight: "75vh" }}>
          <TableContainer className='card card-detail mt-1'>
            <Table variant='simple' size='sm' >
              <Thead>
                <Tr className='tr-border'>
                  <Th className="py-1 th-color">
                    <Checkbox
                      isChecked={selectedRows?.length === data?.length}
                      onChange={handleSelectAllRows} />
                  </Th>
                  <Th className='py-1 th-color'>Actions</Th>
                  <Th className='py-1 th-color'>Employee Id</Th>
                  <Th className='py-1 th-color'>Employee Name</Th>
                  <Th className='py-1 th-color'>Email</Th>
                  <Th className='py-1 th-color'>Date</Th>
                  <Th className='py-1 th-color'>First In</Th>
                  <Th className='py-1 th-color'>Last Out</Th>
                  <Th className='py-1 th-color'>Total Hours</Th>
                  <Th className='py-1 th-color'>Paid Break</Th>
                  <Th className='py-1 th-color'>Payable Hours</Th>
                  <Th className='py-1 th-color'>Created Time</Th>
                  <Th className='py-1 th-color'>Modified Time</Th>
                  <Th className='py-1 th-color'>Created By</Th>

                  {/* <Th className='py-1 th-color'>Status</Th> */}
                </Tr>
              </Thead>
              <Tbody>
                {attendanceData && attendanceData.slice((currentPage - 1) * 30, currentPage * 30).map((item, index) => (
                  <Tr className='tr-border' style={{ cursor: "pointer", position: 'relative' }} >
                    <Td>
                      <Checkbox
                        isChecked={selectedRows.includes(
                          item?.timeSheet?.ROWID
                        )}
                        onChange={() =>
                          handleRowSelect(item?.timeSheet?.ROWID)
                        }
                      />
                    </Td>
                    {/* <Td>
                      <div className="d-flex gap-1">
                        <Link to="/attendance-detail-view" state={{ ROWID: item?.timeSheet?.ROWID }}>
                          <i style={{ cursor: 'pointer' }}><Eye color="#ff176b" size="16px" strokeWidth="1" /></i>
                        </Link>
                        {filterData[16].moduleName === "Employee" && filterData[16].modifyAll === true ?
                          <i onClick={() => { openDrawer(item.timeSheet); setDataToEdit(item.timeSheet); setIsUpdateMode(true) }} style={{ cursor: 'pointer' }}><SquarePen color="#ff176b" size="16px" strokeWidth="1" /></i>
                          : ""}
                        {filterData[16].moduleName === "Employee" && filterData[16].delete === true ?
                          <i style={{ cursor: 'pointer' }}><Trash2 color="#ff176b" size="16px" strokeWidth="1" onClick={(e) => { openTrash(e); setdeleteAttendanceId(item?.timeSheet?.ROWID) }} /></i>
                          : ""} </div>
                    </Td> */}
                    <Td style={{ width: '110px', textAlign: 'center' }} onClick={(e) => e.stopPropagation()}>
                      <EllipsisMenu
                        item={item}
                        onView={() => navigate("/attendance-detail-view", { state: { ROWID: item?.timeSheet?.ROWID } })}
                        onEdit={() => {
                          openDrawer(item.timeSheet);
                          setDataToEdit(item.timeSheet);
                          setIsUpdateMode(true);
                        }}
                        onDelete={() => {
                          openTrash();
                          setdeleteAttendanceId(item?.timeSheet?.ROWID);
                        }}
                        permissions={{
                          canEdit: filterData?.find(mod => mod.moduleName === "Attendance" && mod.modifyAll === true),
                          canDelete: filterData?.find(mod => mod.moduleName === "Attendance" && mod.delete === true),
                          canView: true, // Usually always true, but you can make this dynamic too
                        }}
                      />
                    </Td>
                    <Td className='font-colors'>{item?.timeSheet?.employeeId}</Td>
                    <Td className='font-colors'>{item?.timeSheet?.employeeName}</Td>
                    <Td className='font-colors'>{item?.timeSheet?.email}</Td>
                    <Td className='font-colors'>{formatDate(item?.timeSheet?.dates)}</Td>
                    <Td className='font-colors'>{item?.timeSheet?.firstIn}</Td>
                    <Td className='font-colors'>{item?.timeSheet?.lastOut}</Td>
                    <Td className='font-colors'>{item?.timeSheet?.totalHours}</Td>
                    <Td className='font-colors'>{item?.timeSheet?.paidBreak}</Td>
                    <Td className='font-colors'>{item?.timeSheet?.payableHours}</Td>
                    <Td className='font-colors'>{formatDate(item?.timeSheet?.CREATEDTIME?.slice(0, 16))}</Td>
                    <Td className='font-colors'>{formatDate(item?.timeSheet?.MODIFIEDTIME?.slice(0, 16))}</Td>
                    <Td className='font-colors'>info@trigya.co</Td>

                    {/* <Td className='font-colors'>0</Td> */}
                    {/* <Td className='font-colors'>{item?.timeSheet?.status}</Td> */}
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        </div>
        <div className="footer d-flex fixed-bottom start-20" >
          <div className="total" style={{ marginLeft: '20%', marginTop: '15px' }}>
            <p class="fw-semibold">Total Count: {totalCount}</p>
          </div>
        </div>
        {/* Pagination */}
        <div className="d-flex align-items-center justify-content-center position-fixed-bottom mx-auto" >
          <Pagination totalPages={totalPages} onPageChange={setCurrentPage} />
        </div>
        {/* End Pagination */}
        <AttendanceForm closeDrawer={closeDrawer} isDrawerOpen={isDrawerOpen} isUpdateMode={isUpdateMode} timesheetROWID={timesheetROWID} setIsUpdateMode={setIsUpdateMode} dataToEdit={dataToEdit} onNewAttendanceAdded={handleNewAttendanceAdded} />
      </div>
    </>
  )
}

export default Attendance